<template>
  <div>
    <template v-if="relationList.length">
      <div class="d-flex align-center justify-space-between ga-3 mb-3">
        <div>
          Звʼязків: <b>{{ relationList.length }}</b>
        </div>
        <v-btn
          v-if="!disabled"
          color="light-blue-darken-4"
          @click="relationCreate">
          <v-icon class="mr-2" icon="mdi-link-variant"></v-icon>
          <span>Додати звʼязок</span>
        </v-btn>
      </div>
      <v-card
        v-for="relation in relationList"
        :key="relation.id"
        border
        class="mb-3">
        <v-card-text>
          <div class="d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-file-outline"></v-icon>
              </div>

              <div>
                <div class="font-weight-bold mb-2">
                  {{ relation.docTypeClass.name }}
                  {{ relation.definition.name }}
                  {{ relation.registrationNumber }}
                </div>
                <div class="d-flex ga-3 align-center">
                  <v-chip
                    class="font-weight-bold"
                    color="info"
                    density="compact"
                    rounded="pill">
                    {{ relation.docTypeClass.name }}
                  </v-chip>
                  <v-chip
                    class="font-weight-bold"
                    color="grey"
                    density="compact"
                    rounded="pill">
                    {{ relation.definition.name }}
                  </v-chip>

                  <div class="text-disabled">
                    {{ new CustomDate(relation.created_at).toString() }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!disabled">
              <v-btn
                v-tooltip="'Видалити звʼязок'"
                color="error"
                density="compact"
                icon="mdi-close"
                variant="outlined"
                @click="relationDelete(relation.id)"></v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <div v-else>
      <empty-section
        description="
        Натисніть «Додати звʼязок» щоб звʼязати документи
      "
        title="Немає повʼязаних документів"></empty-section>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex justify-end">
        <v-btn
          v-if="!disabled"
          color="light-blue-darken-4"
          @click="relationCreate">
          <v-icon class="mr-2" icon="mdi-link-variant"></v-icon>
          <span>Додати звʼязок</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import EmptySection from '@/components/EmptySection.vue'
import { useDocument } from '../document'
import { CustomDate } from 'best-modules/utils'

defineOptions({
  name: 'Relation',
})

const { relationList, disabled, relationCreate, relationDelete } = useDocument()
</script>
